




































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import BaseChart from '@/componentsV2/molecules/Chart/BaseChart.vue';

import { IChartDataset, IChartSerie } from '@/models/performance';

import PerformanceUtils from '@/utils/PerformanceUtils';
import { campaignStatisticsFilter } from '@/utils/campaignStatisticsFilter';

export interface ICampaignStatistics {
  datasets: IChartDataset[];
  labels: string[];
}

@Component({ components: { Typography, BaseChart } })
export default class CampaignStatistics extends Vue {
  @Prop() readonly coinsClaimed?: string;
  @Prop() readonly customersClaimed?: string;
  @Prop() readonly campaignId?: string;
  @Prop() campaignCreatedAt?: string;
  @Prop({ default: true }) readonly seeMore?: boolean;
  @Prop({ default: 'small' }) readonly size?: 'large' | 'small';
  @Prop({ default: false }) isDetail?: boolean;
  @Prop({ default: () => [] }) chartSeries?: IChartSerie[];

  options = PerformanceUtils.chartOptions({ colors: ['#3E24D6'] });

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  gotoOfferDetail() {
    this.$analytics({
      eventCategory: 'Free Coins Campaign | See more link',
      eventAction: 'click',
      eventLabel: 'Went to the campaign detail page'
    });

    this.$router.push({
      path: `/marketing-center/offer-free-coins/${this.campaignId}`,
      ...(this.campaignCreatedAt && {
        query: campaignStatisticsFilter(this.campaignCreatedAt)
      })
    });
  }
}
